
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './guiadigitalynxzv.scss';






const Pguiadigitalynxzv = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {
	const [loftystate_ocultargua72a8uk, set_loftystate_ocultargua72a8uk] = useState(true)
	const [loftystate_ocultarprimeraguiafpvxh, set_loftystate_ocultarprimeraguiafpvxh] = useState(true)
	const [loftystate_ocultarsegundaguiat5yyrf, set_loftystate_ocultarsegundaguiat5yyrf] = useState(true)
	const [loftystate_ocultarterceraguiaasrg5, set_loftystate_ocultarterceraguiaasrg5] = useState(true)



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);


	function function_empezarog313_68a7370e8e5aed52dc7cb4b1() {
		set_loftystate_ocultargua72a8uk(true);
		set_loftystate_ocultarprimeraguiafpvxh(true);
	}

	function function_segundarhpgo_68a7373a8e5aed52dc7cb4bc() {
		set_loftystate_ocultarsegundaguiat5yyrf(true);
	}

	function function_tercera98os5_68a737538e5aed52dc7cb4c7() {
		set_loftystate_ocultarterceraguiaasrg5(true);
	}

	function function_ocultartododw71wh_68a737748e5aed52dc7cb4d2() {
		set_loftystate_ocultargua72a8uk(false);
		set_loftystate_ocultarprimeraguiafpvxh(false);
		set_loftystate_ocultarsegundaguiat5yyrf(false);
		set_loftystate_ocultarterceraguiaasrg5(false);
	}


  
  
  
  

  
  return (
    <div id="id68a72c8b8e5aed52dc7cb114" >

      <div id="ibm6" className="">
      
      <div id="iwqt" className="">
      
      <div id="incm3" className="">
      
        <a
          target=""
          className=""
          id="ixtof"
          href="/"
        >
          
      <img
        className=""
        id="iwbnr"
        src="https://assetsprojects.s3.amazonaws.com/404pziime609rgd.png"
        alt="undefined"
      />
      
        </a>
        
      <div id="id16m" className="">
      
        <a
          target=""
          className="link-menu "
          id="ikbb5"
          href="/"
        >
          
    <div id="i5zvy" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iaz2n"
          href="/informacion"
        >
          
    <div id="igsoz" className="">
    <>Nuestra información</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ijoly"
          href="/quehacemos"
        >
          
    <div id="i1fz4" className="">
    <>Que Hacemos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu link-activo "
          id="i6wju"
          href="/guiadigital"
        >
          
    <div id="iu68s" className="">
    <>Guía Digital</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iqw23"
          href="/contacto"
        >
          
    <div id="i97f5" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i2zb" className="">
      
      <div
        id="iqf8z"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="izgm8" className="">
      
      <div id="ix4ee" className="">
      
      <div className="" id="iqji1">
        <>Guía Digital</>
      </div>
      
      <div id="iru8i" className="">
      
      <div className="" id="i9tfg">
        <>espacio informativo diseñado para orientar a los ciudadanos sobre el proceso de votación</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
              <div id="i69bj" className="">
                {
                  loftystate_ocultargua72a8uk && (
                    <div style={{display: 'block'}} className="" id="i5jy6">
                      
      <div id="izwtm" className="">
      
              <div id="i9a0i" className="">
                {
                  loftystate_ocultarprimeraguiafpvxh && (
                    <div style={{display: 'block'}} className="" id="ihqr4">
                      
      <div id="imt9t" className="">
      
      <div
        id="i85el"
        className="papeleta "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="itvnw" className="logo-partido ">
      
      <div className="" id="ivl0x">
        <>Logo del partido</>
      </div>
      
      </div>
      
      <div id="ix3qj" className="foto-papeleta ">
      
      <span className="material-icons " id="ijptg">
        
      <span className="material-icons " id="ihp4h">
        <>account_circle</>
      </span>
      
      </span>
      
      </div>
      
      <div id="irbya" className="votacion ">
      
      </div>
      
      </div>
      
      <div id="i01azc" className="">
      
      <div className="" id="itx7gw">
        <>El emblema del movimiento o alianza entre movimientos</>
      </div>
      
      <div className="" id="it86qg">
        <>La fotografía del candidato</>
      </div>
      
      <div className="" id="i6eu1y">
        <>El espacio en blando</>
      </div>
      
      </div>
      
      </div>
      
      <div id="i6rlh9" className="">
      
      <button
        type=""
        name=""
        id="i21x0w"
        className="boton-principal "
        onClick={async () => {
		function_segundarhpgo_68a7373a8e5aed52dc7cb4bc();
}}

      >
      
      <div id="i2d1n8" className="">
      <>Siguiente</>
      </div>
      
      </button>
      
      </div>
      
                    </div>
                  )
                }
                {
                  !loftystate_ocultarprimeraguiafpvxh && (
                    <div style={{display: 'block'}} className="" id="isayt">
                      
                    </div>
                  )
                }
              </div>
            
              <div id="iqhyf" className="">
                {
                  loftystate_ocultarsegundaguiat5yyrf && (
                    <div style={{display: 'block'}} className="" id="ivuyx">
                      
      <div id="ii4of" className="">
      
      <div
        id="i69tx"
        className="papeleta "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="i4eak" className="logo-partido ">
      
      <div className="" id="iodqg">
        <>Logo del partido</>
      </div>
      
      </div>
      
      <div id="i41ct" className="foto-papeleta ">
      
      <span className="material-icons " id="i828g">
        
      <span className="material-icons " id="iivfi">
        <>account_circle</>
      </span>
      
      </span>
      
      </div>
      
      <div id="ivj3c" className="votacion ">
      
      <img
        className=""
        id="i58x88"
        src="https://assetsprojects.s3.amazonaws.com/404pziimelj5lw4.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="icqjem" className="">
      
      <div className="" id="iekirq">
        <>Para marcar los votos, puede utlizar símbolos gráficos, álfabeticos, numéricos, o una combinación de todos ellos</>
      </div>
      
      </div>
      
      </div>
      
      <div id="idlly6" className="">
      
      <button
        type=""
        name=""
        id="izq2d9"
        className="boton-principal "
        onClick={async () => {
		function_tercera98os5_68a737538e5aed52dc7cb4c7();
}}

      >
      
      <div id="io4hkg" className="">
      <>Siguiente</>
      </div>
      
      </button>
      
      </div>
      
                    </div>
                  )
                }
                {
                  !loftystate_ocultarsegundaguiat5yyrf && (
                    <div style={{display: 'block'}} className="" id="ido8w">
                      
                    </div>
                  )
                }
              </div>
            
              <div id="iet228" className="">
                {
                  loftystate_ocultarterceraguiaasrg5 && (
                    <div style={{display: 'block'}} className="" id="i94uys">
                      
      <div id="ii6nff" className="">
      
      <div
        id="i651vh"
        className="papeleta "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="ivxoq" className="logo-partido ">
      
      <div className="" id="iiug4">
        <>Logo del partido</>
      </div>
      
      </div>
      
      <div id="iidsco" className="foto-papeleta ">
      
      <span className="material-icons " id="ig03jh">
        
      <span className="material-icons " id="icn31a">
        <>account_circle</>
      </span>
      
      </span>
      
      </div>
      
      <div id="ir8dgu" className="votacion ">
      
      <img
        className=""
        id="idy3tl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimelj7qyv.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="i8gijj" className="">
      
      <div className="" id="iz1d4z">
        <>En la papeleta de diputados al Congreso Nacional se permite una marca o raya continua</>
      </div>
      
      </div>
      
      </div>
      
      <div id="itg4ja" className="">
      
      <button
        type=""
        name=""
        id="i64wvy"
        className="boton-principal "
        onClick={async () => {
		function_ocultartododw71wh_68a737748e5aed52dc7cb4d2();
}}

      >
      
      <div id="iayp5f" className="">
      <>Finalizar</>
      </div>
      
      </button>
      
      </div>
      
                    </div>
                  )
                }
                {
                  !loftystate_ocultarterceraguiaasrg5 && (
                    <div style={{display: 'block'}} className="" id="io0mc7">
                      
                    </div>
                  )
                }
              </div>
            
      </div>
      
                    </div>
                  )
                }
                {
                  !loftystate_ocultargua72a8uk && (
                    <div style={{display: 'block'}} className="" id="ittqf">
                      
      <div id="i9nej" className="">
      
      <button
        type=""
        name=""
        id="im32v"
        className="boton-principal "
        onClick={async () => {
		function_empezarog313_68a7370e8e5aed52dc7cb4b1();
}}

      >
      
      <div id="i96te" className="">
      <>Empezar</>
      </div>
      
      </button>
      
      </div>
      
                    </div>
                  )
                }
              </div>
            
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iss5" className="">
      
      <div id="izyl6q" className="">
      
      <div className="" id="iwoln1">
        <>Todos los Derechos Reservadost © 2025 Jovenes al Voto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pguiadigitalynxzv);
  